export default "__VITE_ASSET__CfJ$eUOW__"